import React, { useState } from "react";
import FooterOne from "../common/footer/FooterOne";
import SEO from "../common/SEO";
import API_URL from "../common/config";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import API_URL_dash from "../common/config2";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import HeaderFour from "../common/header/HeaderFour";

const MentorLogin = () => {
  // Login state
  const [email, setUsernameOrEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [activeTab, setActiveTab] = useState("login"); // To toggle between login and signup
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError(""); // Clear any previous errors

    console.log("Sending login request with:", email);

    try {
      const response = await axios.post(`${API_URL}/mentor/auth/login `, {
        email,
        password,
      });

      console.log("Login response:", response);

      if (response.status === 200) {
        const { token, user } = response.data;

        localStorage.setItem("token", token);
        localStorage.setItem("mentorId", user._id);
        // localStorage.setItem("userType", user.userType);
        localStorage.setItem("mentorData", JSON.stringify(user));
        handleNavigation();
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.error(
        "Login error:",
        error.response?.data?.message || "Server error"
      );
      setLoginError(
        error.response?.data?.message || "Invalid email or password"
      );
    }
  };

  // Signup state and handling
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    password: "", // Will be sent as plain text
    userType: "Mentor", // Default to Instructor for MentorLogin page
    acceptedTerms: false,
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};
    if (!formData.firstName) tempErrors.firstName = "First name is required";
    if (!formData.lastName) tempErrors.lastName = "Last name is required";
    if (!formData.username) tempErrors.username = "Username is required";
    if (!formData.email) tempErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      tempErrors.email = "Email is not valid";
    if (!formData.password) tempErrors.password = "Password is required";
    else if (formData.password.length < 6)
      tempErrors.password = "Password must be at least 6 characters";
    if (!formData.userType) tempErrors.userType = "User type is required";
    if (!formData.acceptedTerms)
      tempErrors.acceptedTerms = "You must accept the terms";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await axios.post(
        `${API_URL}/mentor/auth/signup`,
        formData // Sending plain password in formData
      );
      alert("Signup successful!");
      console.log(response.data);
      // Optionally switch to login tab after successful signup
      setActiveTab("login");
    } catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Axios error:", error.message);
      }
    }
  };

  const handleNavigation = () => {
    try {
      // Get user data from localStorage
      const mentorDataRaw = localStorage.getItem("mentorData");
      const mentorId = localStorage.getItem("mentorId");

      // Get tokens if available
      const tokenRaw = localStorage.getItem("token");
      const refreshTokenRaw = localStorage.getItem("refreshToken");

      // Check if we have the essential data
      if (mentorDataRaw && mentorId) {
        // Properly encode the parameters
        const userData = encodeURIComponent(mentorDataRaw);
        const token = tokenRaw ? encodeURIComponent(tokenRaw) : "";
        const refreshToken = refreshTokenRaw
          ? encodeURIComponent(refreshTokenRaw)
          : "";

        // Create the dashboard URL
        const dashboardUrl = `${API_URL_dash}/mentor-dashboard?userData=${userData}&userId=${mentorId}`;

        // Add tokens if available
        const finalUrl = token
          ? `${dashboardUrl}&token=${token}${
              refreshToken ? `&refreshToken=${refreshToken}` : ""
            }`
          : dashboardUrl;

        console.log("Redirecting to dashboard:", finalUrl);

        // Redirect to the dashboard
        window.location.href = finalUrl;
      } else {
        console.error("Missing authentication data for dashboard navigation");
        // Fallback - try direct navigation
        window.location.href = `${API_URL_dash}/mentor-dashboard`;
      }
    } catch (error) {
      console.error("Error navigating to dashboard:", error);
      // Fallback - try direct navigation
      window.location.href = `${API_URL_dash}/dashboard`;
    }
  };

  return (
    <>
      <SEO />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderFour />

        <div
          className="pt--250 pt_lg--200 pt_md--100 pt_sm--80 case-study-page-area"
          style={{
            minHeight: "100vh",
          }}>
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="d-flex mb-4">
                  {/* <button
                    className={`mr-2 btn ${
                      activeTab === "login" ? "btn-primary" : "btn-light"
                    }`}
                    onClick={() => setActiveTab("login")}
                    style={{ marginRight: "10px" }}
                  >
                    Login
                  </button> */}
                  {/* <button
                    className={`btn ${
                      activeTab === "signup" ? "btn-primary" : "btn-light"
                    }`}
                    onClick={() => setActiveTab("signup")}
                  >
                    Sign Up
                  </button> */}
                </div>

                {activeTab === "login" ? (
                  <>
                    <h4>Mentor Login</h4>
                    <hr />
                    {loginError && (
                      <div className="alert alert-danger">{loginError}</div>
                    )}
                    <form onSubmit={handleLogin} className="axil-contact-form">
                      <div className="form-group">
                        <label>Email address*</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="name@gmail.com"
                          name="email"
                          value={email}
                          onChange={(e) => setUsernameOrEmail(e.target.value)}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Password*</label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="******"
                          name="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>

                      <div className="form-group gap-2 flex">
                        <button
                          type="submit"
                          className="axil-btn btn-fill-primary btn-fluid btn-primary"
                          name="submit-btn">
                          Log In
                        </button>
                      </div>
                    </form>
                  </>
                ) : (
                  <>
                    <h4>Mentor Sign Up</h4>
                    <hr />
                    <form onSubmit={handleSubmit} className="axil-contact-form">
                      <div className="form-group">
                        <label>First Name*</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.firstName ? "is-invalid" : ""
                          }`}
                          placeholder="John"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                        />
                        {errors.firstName && (
                          <div className="invalid-feedback">
                            {errors.firstName}
                          </div>
                        )}
                      </div>

                      <div className="form-group">
                        <label>Last Name*</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.lastName ? "is-invalid" : ""
                          }`}
                          placeholder="Doe"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                        />
                        {errors.lastName && (
                          <div className="invalid-feedback">
                            {errors.lastName}
                          </div>
                        )}
                      </div>

                      <div className="form-group">
                        <label>Username*</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.username ? "is-invalid" : ""
                          }`}
                          placeholder="johndoe"
                          name="username"
                          value={formData.username}
                          onChange={handleChange}
                        />
                        {errors.username && (
                          <div className="invalid-feedback">
                            {errors.username}
                          </div>
                        )}
                      </div>

                      <div className="form-group">
                        <label>Email*</label>
                        <input
                          type="email"
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="john@example.com"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>

                      <div className="form-group">
                        <label>Password*</label>
                        <input
                          type="password"
                          className={`form-control ${
                            errors.password ? "is-invalid" : ""
                          }`}
                          placeholder="******"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        {errors.password && (
                          <div className="invalid-feedback">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      <div className="form-group form-check">
                        <input
                          type="checkbox"
                          className={`form-check-input ${
                            errors.acceptedTerms ? "is-invalid" : ""
                          }`}
                          name="acceptedTerms"
                          checked={formData.acceptedTerms}
                          onChange={handleChange}
                          id="acceptTerms"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="acceptTerms">
                          I accept the Terms and Conditions
                        </label>
                        {errors.acceptedTerms && (
                          <div className="invalid-feedback">
                            {errors.acceptedTerms}
                          </div>
                        )}
                      </div>

                      <div className="form-group gap-2 flex">
                        <button
                          type="submit"
                          className="axil-btn btn-fill-primary btn-fluid btn-primary"
                          name="submit-btn">
                          Sign Up
                        </button>
                      </div>
                    </form>
                  </>
                )}
              </div>
              <div className="col-md-6 offset-md-1">
                <img
                  src="/images/banner/banner-thumb-3.png"
                  className="img-responsive"
                  alt="Instructor portal"
                />
              </div>
            </div>
          </div>
        </div>

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default MentorLogin;
